import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Header } from './Header';
import { Info }  from './Info';

const Root = styled.div`
  height: 100%;
`;

const Main = styled.div`
  background-color: ${globalTheme.palette.surface};
  padding: ${globalTheme.spacing.lg};
  margin-bottom: ${globalTheme.spacing.lg};
  border-radius: ${globalTheme.radius.lg};
`;

const ImgContainer = styled.div`
  margin-top: ${globalTheme.spacing.lg};
  display: flex;
  justify-content: center;
`;

const Img = styled.img`
  max-width: 100%;
  max-height: calc(22 * ${globalTheme.spacing.lg});
`;

interface AfterExportProps {
  url: string;
}

export const AfterExport: FC<AfterExportProps> = ({ url }) => (
  <Root>
    <Main>
      <Header url={url} />
      <ImgContainer>
        <Img src={url} />
      </ImgContainer>
    </Main>
    <Info />
  </Root>
);
